export default __webpack_public_path__ + "media/images/icons/assignment-23cc541212f5b6faf54af38332b6c2ab.svg";